<template>
  <div>
    <b-sidebar id="my-sidebar" :title="title" width="90%" bg-variant="white" no-header right backdrop-variant="dark"
      @hidden="hideSideBar" backdrop shadow>
      <div class="margin-side-bar">
        <div>
          <!--  <Messages /> -->
          <b-row>
            <b-col sm="6">
              <div class="title-side-bar">{{ title }}</div>
            </b-col>
            <b-col sm="6">
              <div class="text-right" @click="hide">
                <i class="fa-solid fa-circle-xmark icon-side-bar"></i>
              </div>
            </b-col>
          </b-row>
        </div>
        <br />
        <slot></slot>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import Messages from "@nixweb/nixloc-ui/src/component/shared/Messages";
import { mapState, mapMutations } from "vuex";

export default {
  name: "SideBar",
  components: {
    Messages,
  },
  props: {
    title: String,
  },
  computed: {
    ...mapState("generic", ["sideBar"]),
  },
  methods: {
    ...mapMutations("generic", ["hideSideBar"]),
    hide() {
      this.$root.$emit("bv::toggle::collapse", "my-sidebar");
      this.hideSideBar();
    },
  },
  watch: {
    sideBar: {
      handler(sideBar) {
        if (sideBar.open) {
          this.$root.$emit("bv::toggle::collapse", "my-sidebar");
        }
      },
      deep: true,
    },
  },
};
</script>
<style>
.b-sidebar {
  border-radius: 15px 15px 0px 0px !important;
  margin-top: 20px !important;
  margin-right: 5% !important;
  padding-top: 20px !important;
}

.b-sidebar>.b-sidebar-body {
  overflow-y: scroll !important;
}

.b-sidebar>.b-sidebar-body::-webkit-scrollbar-track {
  background-color: white;
  border-radius: 20px;
}

.b-sidebar>.b-sidebar-body::-webkit-scrollbar {
  width: 6px;
  background-color: #b9babb;
  border-radius: 20px;
}

.b-sidebar>.b-sidebar-body::-webkit-scrollbar-thumb {
  background-color: #b9babb;
  border-radius: 20px;
}

.title-side-bar {
  font-size: 20px;
}

.icon-side-bar {
  font-size: 30px;
  cursor: pointer;
}

.margin-side-bar {
  margin-top: 20px;
  margin-left: 30px;
  margin-right: 20px;
}
</style>